import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import {CommonUtil, LoginService} from '@serengeti/serengeti-common';
import { MenuService } from '@serengeti/serengeti-menu';
import {environment} from "../../../environments/environment";

export interface AuthUserObj {
	ownerId: string;
}

export class AuthServiceBase implements CanActivate {

	protected router: Router;
	protected menuService: MenuService;
	protected loginService: LoginService;
	protected translateService: TranslateService;

  keycloakEndPoint: string;
  isKeycloakUsed: boolean;

	constructor(
		router: Router,
		menuService: MenuService,
		loginService: LoginService,
		translateService: TranslateService,
	) {
		this.router = router;
		this.menuService = menuService;
		this.loginService = loginService;
    this.keycloakEndPoint = environment.serviceKeycloakEndPoint;
    this.isKeycloakUsed = localStorage.getItem("isKeycloakUsed") === "true";
	}

	public isAuthorized(authObj: AuthUserObj): boolean {
		if (authObj) {
			if (authObj.ownerId) {
				if (!authObj.ownerId.localeCompare(this.loginService.getLoginId())) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return true;
		}
	}

	async canActivate(activated: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		const session = this.loginService.getLoginId();

		if (session) {
			if (activated.routeConfig.path === 'main') {
				return true;
			} else {
				const menus = (await this.menuService.getByPath(activated.routeConfig.path).toPromise() as any[]);

				if (menus && menus.length > 0) {
					for (const menu of menus) {
						const roles = menu.roles.map((role: any) => role.userRole);

						for (const role of roles) {
							if (this.loginService.hasRole(role)) {
								return true;
							}
						}
					}
					this.translateService.get('common.invalid.access-menu').subscribe((message: string) => {
						alert(message);
						this.router.navigate(['/main']);
					});

					return false;
				} else {
					return true;
				}
			}
		} else {
      if (this.isKeycloakUsed) {
        const pathAndQuery = window.location.pathname + window.location.search;
        localStorage.setItem('redirectUrl', pathAndQuery);

        const redirectUri = `${window.location.protocol}//${window.location.host}/ssosignin`;
        window.location.href = CommonUtil.buildEndPoint(this.keycloakEndPoint, "user/auth") + "?redirect_uri=" + encodeURIComponent(redirectUri);
      } else {
        this.translateService.get('common.invalid.access-user').subscribe((message: string) => {
          alert(message);
          this.router.navigate(['/member/login'], {queryParams: {returnUrl: state.url}});
        });
        return false;
      }
    }
	}
}
